<template>
	<div class="receipt-box">
		<input type="file" class="hidden" ref="updateFile" :accept="file_types.join(',')" capture @change="e => update_files(e)"/>
		<v-alert type="error" dense class="mb-3" v-if="error_msg.length !== 0">{{ error_msg }}</v-alert>
		<ProgressGetDataLinear v-if="settings_loading" class="receipt-loading px-5"/>
		<v-row v-if="!settings_loading">
			<v-col v-if="image_type.length !== 0" :cols="$vuetify.breakpoint.smAndDown ? 12: 4" class="px-2 pt-1">
				<div v-if="image">
					<div v-if="image_type !== pdf_file_type" class="wrap-div">
						<div :style="{width:image_width+'px', height: image_height+'px' , transform:'scale('+multiples+')',transformOrigin:'center'}">
							<img
								v-drag
								class="image-show-box"
								:src="typeof(image) === 'string' ? image : image[0]" 
								width="100%" 
								alt="receipt" />
						</div>
					</div>
					<div v-if="image_type === pdf_file_type && image.length === 1" class="wrap-div">
						<div :style="{width:image_width+'px', height: image_height+'px' , transform:'scale('+multiples+')',transformOrigin:'center'}">
							<img
								v-drag
								class="image-show-box"
								:src="image[0]" 
								width="100%" 
								alt="receipt" />
						</div>
					</div>
					<v-carousel v-if="image_type === pdf_file_type && image.length > 1" v-model="multi_pdf_model" hide-delimiters height="100%">
						<v-carousel-item
							v-for="(image_item, index) in image"
							:key="index"
						>
							<div :style="{width:image_width+'px', height: image_height+'px' , transform:'scale('+multiples+')',transformOrigin:'center'}">
								<img
									v-drag
									class="image-show-box"
									:src="image_item" 
									width="100%"
									alt="receipt" />
							</div>
						</v-carousel-item>
					</v-carousel>
					<v-btn small color="#82899B" class="image-remove white--text text-capitalize" @click="onImageRemove()">
						<v-icon small class="mr-1">mdi-close</v-icon>
						<span>Remove</span>						
					</v-btn>
					<v-btn v-if="!$vuetify.breakpoint.smAndDown" small color="#82899B" class="image-zoom white--text text-capitalize" @click.stop="openZoom()">
						<span>Open</span>
					</v-btn>
				</div>
				<v-row
					v-else
					class="image-loading fill-height ma-0"
					align="center"
					justify="center"
				>
					<v-progress-circular
						:size="50"
						:width="5"
						color="grey lighten-5"
						indeterminate
					></v-progress-circular>
				</v-row>
			</v-col>
			<v-col :cols="image_type.length === 0 ? 12 : ($vuetify.breakpoint.smAndDown ? 12: 8)">
				<v-row>
					<v-col class="px-2">
						<div class="receipt-box-text mt-0">Expense Date</div>
						<v-row class="ma-0" justify="space-between">
							<DatePicker
								:color="color" 
								:lableText="''"
								:isOutlined="true"
								:isIcon="true"
								:disabled="isFinance"
								:dateInit="expenses_date_init"
								@date="expenses_date = $event"
							/>
							<v-btn
								v-if="!image"
								depressed
								outlined
								color="#00AAFD"
								height="40"
								class="text-capitalize px-5"
								@click="onAddFile()">
								<v-icon size="24" class="mr-2">mdi-plus</v-icon>
								Add File
							</v-btn>
						</v-row>
						<v-row class="ma-0">
							<v-col cols="12" class="pa-0">
								<div class="receipt-box-text">Job</div>
								<v-autocomplete
									v-model="job"
									:items="job_items"
									:loading="job_loading"
									:search-input.sync="jobSearch"
									:color="color"
									:placeholder="`Type to search`"
									background-color="#FAFAFA"
									item-text="display_name"
									item-value="id"
									:item-color="color"
									item-disabled="disabled"
									auto-select-first
									outlined
									dense
									hide-no-data
									hide-details
									return-object
									clearable
									@change="onSelectJob($event)"
								>
								</v-autocomplete>
							</v-col>
						</v-row>
						<v-row class="ma-0 mt-4">
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'pa-0 pr-2'">
								<div class="receipt-box-text">Phase</div>
								<v-select
									v-model="phase"
									:items="phases_local"
									item-text="display_name"
									item-value="id"
									:item-color="color"
									background-color="#FAFAFA"
									dense
									hide-details
									return-object
									outlined
									:color="color"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 mt-4' : 'pa-0 pl-2'">
								<div class="receipt-box-text">Kind</div>
								<KindTreeSelection
									:elementKey="`kind`"
									:color="color"
									:placeholder="'Type to search, e.g., PRINT - Printing'"
									:kindParams="kindParams"
									:kindSelected="kind_selected"
									:bgColor="'#FAFAFA'"
									@kind-selected="onKindSelected($event)"
								/>
							</v-col>
						</v-row>
						<v-row class="ma-0 mt-4">
							<v-col cols="12" class="pa-0">
								<div class="receipt-box-text">Description</div>
								<v-text-field
									:color="color"
									v-model="description"
									background-color="#FAFAFA"
									hide-details
									dense
									outlined
								/>
							</v-col>
						</v-row>
						<v-row class="ma-0 mt-4">
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" class="pa-0 pr-1">
								<div class="receipt-box-text">Currency</div>
								<v-select
									v-model="currency"
									:items="currencies"
									item-text="code"
									item-value="id"
									:item-color="color"
									background-color="#FAFAFA"
									dense
									hide-details
									return-object
									outlined
									:color="color"
									:messages="currencyMsg"
									@change="onCurrencyChange($event)"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1' : 'pa-0 pl-1 pr-2'">
								<div class="receipt-box-text">Amount</div>
								<v-text-field
									:value="formatAmount(amount)"
									class="text-right"
									background-color="#FAFAFA"
									dense
									hide-details
									:color="color"
									outlined
									min="0"
									oninput="if(this.value < 0) this.value = 0"
									@change="amount = parseAmount($event)"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pr-1 mt-4' : 'pa-0 pl-2 pr-1'">
								<div class="receipt-box-text">Tax</div>
								<v-text-field
									:value="formatAmount(tax_amount)"
									class="text-right"
									background-color="#FAFAFA"
									dense
									hide-details
									:color="color"
									:disabled="isTaxDisabled"
									outlined
									min="0"
									oninput="if(this.value < 0) this.value = 0"
									@change="onTaxChange($event)"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 pl-1 mt-4' : 'pa-0 pl-1'">
								<div class="receipt-box-text">To Pay</div>
								<v-text-field
									:value="toPay"
									background-color="#FAFAFA"
									outlined
									disabled
									dense
									:messages="toPayMsg"
									hide-details
								>
								</v-text-field>
							</v-col>
						</v-row>
						<v-row class="ma-0 mt-4">
							<v-btn class="text-capitalize px-1" color="#82899B" text @click="onShowToogle()">
								<span v-if="is_show_toogle">Hide tax and markup</span>
								<span v-else>Change tax and markup</span>
							</v-btn>
						</v-row>
						<v-row v-if="is_show_toogle" class="ma-0 mt-2">
							<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" class="pa-0 pr-1">
								<div class="receipt-box-text">Mark up</div>
								<v-text-field
									class="mark-up-field"
									:value="formatAmount(markup_perc)"
									background-color="#FAFAFA"
									append-icon="mdi-percent"
									dense
									hide-details
									:color="color"
									outlined
									min="0"
									oninput="if(this.value < 0) this.value = 0;"
									:disabled="isMarkupDisabled"
									@change="markup_perc = parseAmount($event)"
								/>
							</v-col>
							<v-col v-if="isShowMarkup" :cols="$vuetify.breakpoint.xsOnly ? 6 : 3" class="pa-0 pl-1 pr-2">
								<div class="receipt-box-text">Value</div>
								<v-text-field
									:value="markupValue"
									outlined
									disabled
									dense
									hide-details
									background-color="#FAFAFA"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'pa-0 mt-4' : 'pa-0 pl-2'">
								<div class="receipt-box-text">Tax Settings</div>
								<v-select
									v-model="tax_setting"
									:items="tax_settings"
									:item-color="color"
									background-color="#FAFAFA"
									dense
									hide-details
									return-object
									outlined
									:color="color"
									@change="onTaxSettingChange"
								/>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row class="ma-0 mt-6" align="end">
					<v-btn
						class="text-capitalize white--text mr-3"
						color="#00AAFD"
						depressed
						:disabled="!isSaveExpenseEnabled"
						@click.stop="onSave()"
					>
						Save Expense
					</v-btn>
					<v-btn class="text-capitalize" color="#82899B" depressed outlined @click.stop="onCancel()">
						Cancel
					</v-btn>
				</v-row>
			</v-col>
		</v-row>
		<v-overlay :value="overlay">
			<v-row
				class="fill-height ma-0"
				align="center"
				justify="center"
			>
				<v-progress-circular
					:size="70"
					:width="5"
					color="grey lighten-5"
					indeterminate
				></v-progress-circular>
			</v-row>
		</v-overlay>
		<ReceiptImageView 
			v-if="image_visible"
			:visible="image_visible" 
			:show_image="show_image"
			@image-close="image_visible = false"
		/>
	</div>
</template>
<script>
import moment from 'moment';
import heic2any from 'heic2any';
import config from "@/config.js";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import DatePicker from "@/components/date/date_picker.vue";
import ReceiptImageView from "@/views/expenses/receipts/receipt_image_view.vue";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const MAX_FILE_SIZE = 6;
const QUALITY = 0.5;
const FILE_TYPE = ['image/jpeg','image/png','image/heic','image/heic-sequence','application/pdf'];
const SCALE = 1.2;
const PAGE_INIT = 0;

const PDF_TYPE = 'application/pdf';
const Max_Distance_Mobile = 48;
const Max_Distance_Window = 68;

/** If ticked the user can see markups configured in the system */
const MUVW = 'MUvw';
/** If ticked the user can modify markups configured in the system */
const MUAM = 'MUam';

export default {
	name:'EditReceipt',
	props: {
		color: {
			type: String,
			default: '',
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		phases: {
			type: Array,
			default: () => [],
		},
		receipt: {
			type: Object,
			default: () => {}
		},
		isFinance: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: ''
		}
	},
	components: {
		KindTreeSelection,
		DatePicker,
		ReceiptImageView,
		ProgressGetDataLinear
	},
	data() {
		this.pdf_file_type = FILE_TYPE[FILE_TYPE.length - 1];

		return {
			error_msg: '',
			max_width: this.$vuetify.breakpoint.height * 0.9 - 40,
			file_types: FILE_TYPE,
			settings_loading: false,
			overlay: false,
			
			job_loading :false,
			jobSearch: null,
			is_show_toogle: false,
			
			expenses_date_init: this.receipt ? this.receipt.date : '',
			expenses_date: this.receipt ? this.receipt.date : null,
			job: this.receipt ? this.receipt.job : null,
			job_items: this.receipt ? [this.receipt.job]: [],
			phase: this.receipt ? this.receipt.phase : null,
			phases_local: this.phases,
			kind: this.receipt ? this.receipt.kind : null,
			kind_selected: this.receipt ? this.receipt.kind : null,
			description: this.receipt ? this.receipt.description :'',
			currency: this.receipt ? this.currencies.find(c => { return c.id === this.receipt.currency.id }) : null,
			amount: this.getAmount(),
			tax_amount: this.receipt ? this.parseAmount(this.receipt.tax_amount) : 0,
			tax_amount_original: this.receipt ? this.parseAmount(this.receipt.tax_amount) : 0,
			tax_perc: this.receipt ? this.parseAmount(this.receipt.tax_perc) : 0,
			markup_perc: this.receipt ? this.parseAmount(this.receipt.markup_perc) : 0,
			tax_setting: this.receipt
				? config.tax_settings.find(tax_setting => { return tax_setting.value === this.receipt.tax_mode })
				: null,
			tax_settings: config.tax_settings,
			has_tax: this.receipt ? this.receipt.has_tax : true,

			image_type: this.receipt ? this.receipt.image_type : '',
			image: null,
			image_origin: null,
			image_save_obj: null,

			multiples: 1,
			image_height: 0,
			image_width: 0,
			multi_pdf_model: 0,

			image_visible: false,
			show_image: null
		}
	},
	directives: {
		drag: function (el) {
			let oDiv = el;
			oDiv.onmousedown = function (e) {
				e.preventDefault();
				let bw = document.body.clientWidth;
				let bh = document.body.clientHeight;
				
				let disX = e.clientX - oDiv.offsetLeft;
				let disY = e.clientY - oDiv.offsetTop;

				document.onmousemove = function (e) {
					let l = 0, t = 0;

					if (e.clientX >= bw) {
						l = bw - disX;
					} else if (e.clientX <= 0) {
						{
							l = 0- disX;
						}
					} else {
						l = e.clientX - disX;
					}
					if (e.clientY >= bh) {
						t = bh - disY;
					}else if(e.clientY <= 0) {
						t = 0- disY;
					}
					else {
						t = e.clientY - disY;
					}
					
					oDiv.style.left = l + 'px';
					oDiv.style.top = t + 'px';
				};

				document.onmouseup = function () {
					document.onmousemove = null;
					document.onmouseup = null;
				};
			};
		}
	},
	created() {
		this.getSettings();

		if (this.job && !this.phase) {
			this._getPhases(this.job.id);
		}
		if (this.receipt && this.receipt.image_type && this.receipt.image_type.length !== 0) {
			this.getImage(this.receipt);
		}
	},
	mounted() {
		if (this.receipt && this.receipt.tax_mode !== 1 && this.receipt.tax_mode !== 4 && Number(this.receipt.tax_amount) === 0) {
			const countries = this.currency.countries || [];
			const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
			if (!country) return;

			this.tax_perc = Number(country.tax_perc);
		}
		if (this.receipt && this.receipt.tax_mode !== 1 && this.receipt.tax_mode !== 4) {
			const countries = this.currency.countries || [];
			const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
			if (!country) return;

			const tax_perc = Number(country.tax_perc);
			if (Number(this.receipt.tax_perc) !== tax_perc) {
				this.tax_perc = Number(country.tax_perc);
			}
		}
	},
	watch: {
		receipt: {
			handler: function () {
				this.expenses_date_init = this.receipt ? this.receipt.date : '';
				this.expenses_date = this.receipt ? this.receipt.date : null;
				this.job = this.receipt ? this.receipt.job : null;
				this.job_items = this.receipt ? [this.receipt.job] : [];
				this.phase = this.receipt ? this.receipt.phase : null;
				this.kind = this.receipt ? this.receipt.kind : null;
				this.kind_selected = this.receipt ? this.receipt.kind : null;
				this.description = this.receipt ? this.receipt.description : '';
				this.currency = this.receipt ? this.receipt.currency : null;
				this.amount = this.getAmount();
				this.tax_amount = this.receipt ? this.parseAmount(this.receipt.tax_amount) : 0;
				this.tax_amount_original = this.receipt ? this.parseAmount(this.receipt.tax_amount) : 0;
				this.tax_perc = this.receipt ? this.parseAmount(this.receipt.tax_perc) : 0;
				this.markup_perc = this.receipt ? this.parseAmount(this.receipt.markup_perc) : 0;
				this.tax_setting = this.receipt
					? config.tax_settings.find(tax_setting => { return tax_setting.value === this.receipt.tax_mode })
					: null;
				this.tax_settings = config.tax_settings;
				this.has_tax = this.receipt ? this.receipt.has_tax : true;

				this.image_type = this.receipt ? this.receipt.image_type : '';
				this.image = null;
				if (this.receipt.image_type.length !== 0) {
					this.getImage(this.receipt);
				}
			},
			deep: true
		},
		jobSearch(val) {
			this.job ? val && val !== this.job.display_name && this.jobQuery(val) : val && this.jobQuery(val);
		},
		phases() {
			this.phases_local = this.phases;
		},
		phase() {
			if (this.job && this.phase && this.kind) {
				this._checkKind(this.job.id, this.kind.id, this.phase.id)
					.then(val => {
						if (!val) {
							this.kind = null;
							this.kind_selected = null;
						}
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}
		},
		amount(new_val, old_val) {
			if (old_val !== new_val) {
				const countries = this.currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
				this.tax_amount = this.has_tax ? Number(new_val) * this.tax_perc * 0.01 : 0;
						
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
		errorMessage() {
			if (this.errorMessage.length !== 0) {
				this.error_msg = this.errorMessage;
			}
		},
	},
	computed: {
		isSaveExpenseEnabled() {
			if (!this.receipt) {
				return false;
			}

			const has_required_fields = this.expenses_date && this.expenses_date.length !== 0
				&& this.job
				&& this.phase
				&& this.kind
				&& this.currency
				&& this.parseAmount(this.amount) !== 0;

			if (!has_required_fields) {
				return false;
			}

			const get_id = value => value ? value.id : null;
			const original_description = this.receipt.hasOwnProperty('description')
				? this.receipt.description
				: this.receipt.desc;
			const original_tax_mode = this.receipt.tax_mode !== undefined
				? this.receipt.tax_mode
				: this.receipt.tax_setting && this.receipt.tax_setting.value;
			const current_tax_mode = this.tax_setting ? this.tax_setting.value : null;

			const has_field_changes = this.expenses_date !== this.receipt.date
				|| get_id(this.job) !== get_id(this.receipt.job)
				|| get_id(this.phase) !== get_id(this.receipt.phase)
				|| get_id(this.kind) !== get_id(this.receipt.kind)
				|| get_id(this.currency) !== get_id(this.receipt.currency)
				|| this.description !== original_description
				|| this.parseAmount(this.amount) !== this.getAmount()
				|| this.parseAmount(this.tax_amount) !== this.parseAmount(this.receipt.tax_amount)
				|| this.parseAmount(this.markup_perc) !== this.parseAmount(this.receipt.markup_perc)
				|| current_tax_mode !== original_tax_mode

			let has_image_changes = this.image_type !== this.receipt.image_type;
			if (!has_image_changes && this.image_type === this.pdf_file_type) {
				has_image_changes = Boolean(this.image_origin && this.image
					&& (this.image_origin.length !== this.image.length || this.image_origin[0] !== this.image[0]));
			} else if (!has_image_changes) {
				has_image_changes = Boolean(this.image_origin && this.image && this.image_origin !== this.image);
			}

			return has_field_changes || has_image_changes;
		},
		isTaxDisabled() {
			const tax_setting_value = this.tax_setting ? Number(this.tax_setting.value) : null;
			return tax_setting_value === 1 || tax_setting_value === 4;
		},
		isShowMarkup() {
			let is_show_markup = false;

			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0) {
				const privileges = this.$store.state.privileges;
				is_show_markup = privileges.includes(MUVW) ? true : false;
			}

			return is_show_markup;
		},
		isEditMarkup() {
			let is_edit_markup = false;
			
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0) {
				const privileges = this.$store.state.privileges;
				is_edit_markup = privileges.includes(MUAM) ? true : false;
			}

			return is_edit_markup;
		},
		isMarkupDisabled() {
			return !this.isEditMarkup
				|| Number(this.markup_perc) < 0
				|| (this.job && this.job.is_overhead === true)
				|| (this.kind && Number(this.kind.overhead_mode) === 2);
		},
		userId() {
			let user_id = 0;

			if (this.$store.state.user) {
				user_id = this.$store.state.user.id;
			}

			return user_id;
		},
		kindParams() {
			const kind_params = {
				select_kinds: true,
				select_items: true,
				expense_kinds: true,
				overhead_mode: 0
			};

			if (this.job) {
				if (this.job.is_overhead === true) {
					kind_params.overhead_mode = 2;
				} else {
					kind_params.overhead_mode = 1;
				}
			}

			return kind_params;
		},
		toPay() {
			const amount = Number(this.amount) || 0;
			const tax = Number(this.tax_amount) || 0;
			const to_pay = amount + tax;

			return this.formatAmount(to_pay);
		},
		markupValue() {
			const amount = Number(this.amount) || 0;
			const mark_up_tmp = Number(this.markup_perc) || 0;
			const value_amount = amount + (amount * mark_up_tmp * 0.01);

			return this.formatAmount(value_amount);
		},
		currencyMsg() {
			let msg = '';
			if (this.isFinance && this.receipt.origin_currency.id !== this.currency.id) {
				msg = `Expense currency = ${this.receipt.origin_currency.code}`;
			}
			return msg;
		},
		toPayMsg() {
			let msg = '';
			if (this.isFinance && this.receipt.origin_currency.id !== this.currency.id) {
				msg = `Expense amount = ${ this.receipt.origin_value }`;
			}
			return msg;
		}
	},
	methods: {
		formatAmount(value) {
			// from nmber to string, 12345.00 -> 12,345.00
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		parseAmount(value) {
			// from string to nmber, 12,345.00 -> 12345.00 
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		getAmount() {
			if (!this.receipt) {
				return 0;
			}

			return this.receipt.gross !== null && this.receipt.gross !== undefined
				? this.parseAmount(this.receipt.gross)
				: this.parseAmount(this.receipt.value);
		},
		getMarkup(job_id, kind_id) {
			let url = "/api/config/rates/markup";

			const params = [];
			params.push("job_id=" + job_id);
			params.push("kind_id=" + kind_id);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.markup_perc = data * 100;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		getSettings() {
			this.settings_loading = true;
			const usid = this.userId;
			const winname = 'webclaim';

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const toogle = windata.toogle;
								if (toogle !== null || toogle !== undefined) {
									this.is_show_toogle = toogle;
								}
							}
						}
						this.settings_loading = false;
					} else {
						this.error_msg = reason;
						this.settings_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.settings_loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.userId;
			const winname = 'webclaim';

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		jobQuery(key) {
			this.job_loading = true;
			
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));
			params.push("status_groups=" + config.job_status_group_nomal.toString());
			params.push('is_lookup' + '=' + encodeURIComponent(false));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						const code_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						const data_filter = [...code_data, ...desc_data];

						this.job_items = data_filter;
						this.job_loading = false;
					} else {
						this.error_msg = reason;
						this.job_loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.job_loading = false;
				})
				.finally(() => {
					this.job_loading = false;
				});
		},
		onSelectJob(job) {
			if (!job) return;

			this.job = job;
			this.phase = null;
			this._getPhases(job.id);

			if (job.currency) {
				this.currency = this.currencies.find(c => { return c.id === job.currency.id });

				if (this.currency ) {
					const countries = this.currency.countries || [];
					const country = countries.find(c => { return job.country && c.id === job.country.id }) || countries[0];
					if (!country) return;

					this.tax_perc = Number(country.tax_perc);
						
					/** has_tax=true => Tax applies; has_tax=false => Tax free */
					this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
					this.onTaxSettingChange(this.tax_setting);
				}
			}
				
			if (job && this.phase && this.kind) {
				this._checkKind(job.id, this.kind.id, this.phase.id)
					.then(val => {
						if (!val) {
							this.kind = null;
							this.kind_selected = null;
						}
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}
			if (job && this.kind) {
				this.getMarkup(job.id, this.kind.id);
			}
		},
		onKindSelected(kind) {
			this.kind = kind;
			this.kind_selected = kind;

			if (kind && this.job) {
				this.getMarkup(this.job.id, kind.id);
			}
		},
		onCurrencyChange(currency) {
			if (currency) {
				const countries = currency.countries || [];
				const country = countries.find(c => { return this.job && this.job.country && c.id === this.job.country.id }) || countries[0];
				if (!country) return;

				this.tax_perc = Number(country.tax_perc);
				
				/** has_tax=true => Tax applies; has_tax=false => Tax free */
				this.tax_setting = country.has_tax === true ? this.tax_settings.find(tax => { return tax.value === 0 }) : this.tax_settings.find(tax => { return tax.value === 1 });
				this.onTaxSettingChange(this.tax_setting);
			}
		},
		onTaxChange(value) {
			this.tax_amount = this.parseAmount(value);

			if (Number(this.tax_amount) === 0) {
				const tax_free_setting = this.tax_settings.find(setting => setting.value === 1);

				if (tax_free_setting) {
					this.onTaxSettingChange(tax_free_setting);
				}
			}
		},
		onTaxSettingChange(tax_setting) {
			if (!tax_setting) {
				this.has_tax = false;
				this.tax_amount = 0;
				return;
			}

			this.tax_setting = tax_setting;
			
			if (tax_setting.value === 1 || tax_setting.value === 4) {
				this.has_tax = false;
				this.tax_amount = 0;
			} else {
				this.has_tax = true;
				this.tax_amount = Number(this.amount) * this.tax_perc * 0.01;
			}
		},
		onShowToogle() {
			this.is_show_toogle = !this.is_show_toogle;

			const win_setup_obj = {
				toogle: this.is_show_toogle,
			};
			const win_setup_str = JSON.stringify(win_setup_obj);

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onSave() {
			if (this.job && this.kind && this.kind.overhead_mode === 1 && !this.job.is_overhead) {
				this.error_msg = "You can't use an overhead kind on a client job";
				return ;
			} else if (this.job && this.kind && this.kind.overhead_mode === 0 && this.kind.show_over === 0 && this.job.is_overhead) {
				this.error_msg = "You can't use a client kind on an overhead job";
				return ;
			};

			this._imageCheckAndSave();
		},
		onCancel() {
			this.$emit('close');
		},
		onImageRemove() {
			/** this step is not delete image from database, just hide it */
			this.image = null;
			this.image_type = '';
			this.image_height = 0;
			this.image_width = 0;			
		},
		onAddFile() {
			this.$refs.updateFile.click();
		},
		update_files(e) {
			/** this step is not add image to database, just show it */
			const file = e.target.files[0];
			console.log('file-before-size:', file.size/1024, 'kb');

			if (!file) {
				return;
			}
			if (!FILE_TYPE.includes(file.type)) {
				this.error_msg = `File: ${file.name}, invalid file type`;
				return;
			}
			if (file.size > 1000 * 1000 * MAX_FILE_SIZE) {
				this.error_msg = `File: ${file.name}, over maximum ${MAX_FILE_SIZE}MB size`;
				return;
			}

			const reader = new FileReader();
			reader.readAsDataURL(file); 

			if (file.type === this.pdf_file_type) {
				reader.onload = readerEvent =>  {
					const pdf_data = readerEvent.target.result;

					const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
					loadingTask.promise.then(pdf => {
						const preview_url = [];
						let page_total = pdf.numPages;

						for (let index = 0; index < pdf.numPages; index++) {
							pdf.getPage(index + 1).then(page => {
								const scale = SCALE;
								const viewport = page.getViewport({scale: scale});

								const canvas = document.createElement('canvas');
								const context = canvas.getContext('2d');
								canvas.width = viewport.width;
								canvas.height = viewport.height;

								const renderContext = {
									canvasContext: context,
									viewport: viewport
								};
								const renderTask = page.render(renderContext);
								renderTask.promise.then(() => {
									canvas.toBlob(blob => {
										const preview_item_url = URL.createObjectURL(blob);
										preview_url.push(preview_item_url);

										page_total -= 1;

										if (page_total === PAGE_INIT) {
											let image_width = 0;
											let image_height = 0;

											if (this.$vuetify.breakpoint.smAndDown) {
												/* 48 = padding-left-24px + padding-right-24px */
												if (viewport.width > viewport.height) {
													image_width = this.$vuetify.breakpoint.width - 48;
													image_height = (this.$vuetify.breakpoint.width - 48) * viewport.height / viewport.width;
												} else {
													image_height = this.$vuetify.breakpoint.width - 48;
													image_width = (this.$vuetify.breakpoint.width - 48) * viewport.width / viewport.height;
												}
											} else {
												if (viewport.width > viewport.height) {
													image_width = this.max_width;
													image_height = this.max_width * viewport.height / viewport.width;
												} else {
													image_height = this.max_width;
													image_width = this.max_width * viewport.width / viewport.height;
												}
											}
										
											this.image_type = file.type;
											this.image = preview_url;
											this.image_width = image_width;
											this.image_height = image_height;
											
											const blob = this._dataURItoBlob(pdf_data);
											console.log('file-after-size:', blob.size /1024, 'kb');

											const image_obj = {
												blob: blob,
												image: preview_url,
												image_type: file.type,
												image_width: image_width,
												image_height: image_height,
											};
											this.image_save_obj = image_obj;
										}
									});									
								});
							});
						}
					});
				};	
			} else if (file.type === 'image/heic' || file.type === 'image/heic-sequence') {
				heic2any({ blob: file, toType: 'image/jpeg' }).then((blob) => {
					reader.readAsDataURL(blob);

					const my_image = new Image();
					reader.onload = readerEvent =>  {
						my_image.src = readerEvent.target.result;
						my_image.onload = () => {
							const resize_data = this._resizeByQuality(my_image, 1);
							const blob = this._dataURItoBlob(resize_data);
							console.log('file-after-size:', blob.size /1024, 'kb');

							const preview_url = URL.createObjectURL(blob);

							let image_width = 0;
							let image_height = 0;

							if (this.$vuetify.breakpoint.smAndDown) {
								/* 48 = padding-left-24px + padding-right-24px */
								if (my_image.width > my_image.height) {
									image_width = this.$vuetify.breakpoint.width - 48;
									image_height = (this.$vuetify.breakpoint.width - 48) * my_image.height / my_image.width;
								} else {
									image_height = this.$vuetify.breakpoint.width - 48;
									image_width = (this.$vuetify.breakpoint.width - 48) * my_image.width / my_image.height;
								}
							} else {
								if (my_image.width > my_image.height) {
									image_width = this.max_width;
									image_height = this.max_width * my_image.height / my_image.width;
								} else {
									image_height = this.max_width;
									image_width = this.max_width * my_image.width / my_image.height;
								}
							}

							this.image_type = FILE_TYPE[0];
							this.image = preview_url;
							this.image_width = image_width;
							this.image_height = image_height;
											
							const image_obj = {
								blob: blob,
								image: preview_url,
								image_type: FILE_TYPE[0],
								image_width: image_width,
								image_height: image_height,
							};
							this.image_save_obj = image_obj;
						}
					};					
				}).catch((e) => {
					this.error_msg = e.message;
				});
			} else {
				const my_image = new Image();
				reader.onload = readerEvent =>  {
					my_image.src = readerEvent.target.result;
					my_image.onload = () => {
						const resize_data = this._resizeByQuality(my_image, QUALITY);
						const blob = this._dataURItoBlob(resize_data);
						console.log('file-after-size:', blob.size /1024, 'kb');
						
						const preview_url = URL.createObjectURL(file);
						let image_width = 0;
						let image_height = 0;

						if (this.$vuetify.breakpoint.smAndDown) {
							/* 48 = padding-left-24px + padding-right-24px */
							if (my_image.width > my_image.height) {
								image_width = this.$vuetify.breakpoint.width - 48;
								image_height = (this.$vuetify.breakpoint.width - 48) * my_image.height / my_image.width;
							} else {
								image_height = this.$vuetify.breakpoint.width - 48;
								image_width = (this.$vuetify.breakpoint.width - 48) * my_image.width / my_image.height;
							}
						} else {
							if (my_image.width > my_image.height) {
								image_width = this.max_width;
								image_height = this.max_width * my_image.height / my_image.width;
							} else {
								image_height = this.max_width;
								image_width = this.max_width * my_image.width / my_image.height;
							}
						}

						this.image_type = file.type;
						this.image = preview_url;
						this.image_width = image_width;
						this.image_height = image_height;

						const image_obj = {
							blob: blob,
							image: preview_url,
							image_type: file.type,
							image_width: image_width,
							image_height: image_height,
						};
						this.image_save_obj = image_obj;
					}
				};
			}
		},
		upload_receipt_for_image(image_save_obj) {
			return new Promise((resolve,reject) => {
				const url = `/api/expenses/receipts/${this.receipt.id}/image`;

				this.overlay = true;

				axios
					.put(url, image_save_obj.blob, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, reason } = val.data;
						if (status == "OK") {
							if (this.isFinance) {
								const obj = {
									image: url,
									image_type: image_save_obj.image_type,
									image_width: 0,
									image_height: 0,
								};
								this.$emit('update-file', obj);
							}

							resolve();
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e);
					});
			});
		},
		delete_receipt_for_image() {
			return new Promise((resolve,reject) => {
				const url = `/api/expenses/receipts/${this.receipt.id}/image`;

				this.overlay = true;

				axios
					.delete(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, reason } = val.data;

						if (status == "OK") {
							if (this.isFinance) {
								const obj = {
									image: null,
									image_type: '',
									image_width: 0,
									image_height: 0,
								};
								this.$emit('update-file', obj);
							}

							resolve();
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e);
					});
			});			
		},
		getImage(item) {
			if (item.image_type === this.pdf_file_type) {
				const url = `/api/expenses/receipts/${item.id}/image`;
				this._getBlobDate(url);
			} else {
				const index = item.image.lastIndexOf('/');
				const image = item.image.slice(0, index + 1) + 'image';
			
				let image_width = 0;
				let image_height = 0;

				const my_image = new Image();
				my_image.src = image;
				my_image.onload = () => {
					if (this.$vuetify.breakpoint.smAndDown) {
						/* 48 = padding-left-24px + padding-right-24px */
						if (my_image.width > my_image.height) {
							image_width = this.$vuetify.breakpoint.width - 48;
							image_height = (this.$vuetify.breakpoint.width - 48) * my_image.height / my_image.width;
						} else {
							image_height = this.$vuetify.breakpoint.width - 48;
							image_width = (this.$vuetify.breakpoint.width - 48) * my_image.width / my_image.height;
						}
					} else {
						if (my_image.width > my_image.height) {
							image_width = this.max_width;
							image_height = this.max_width * my_image.height / my_image.width;
						} else {
							image_height = this.max_width;
							image_width = this.max_width * my_image.width / my_image.height;
						}
					}

					this.image_width = image_width;
					this.image_height = image_height;
					this.image = image;
					this.image_origin = image;
				}
			}
		},
		zoomIn(){
			if(this.multiples >= 3){
				return
			}
			this.multiples += 0.25
		},
		zoomOut(){
			if(this.multiples <= 0.5){
				return
			}
			this.multiples -= 0.25
		},
		openNewTab() {
			/** keep this, if want to open a new tab to show the image */
			if (this.image_save_obj) {
				const eleLink = document.createElement('a');

				const userAgent = navigator.userAgent;
				if (userAgent.includes('Firefox')) {
					eleLink.download = `JBX_${this.receipt.id}/image`;
				}
						
				eleLink.style.display = 'none';
				if (!this.$vuetify.breakpoint.smAndDown) {
					eleLink.target = '_blank';
				}
				eleLink.href = URL.createObjectURL(this.image_save_obj.blob);
				document.body.appendChild(eleLink);
				eleLink.click();
				document.body.removeChild(eleLink);
				window.URL.revokeObjectURL(eleLink.href);
			} else {
				const url = this.receipt.image ? this.receipt.image: `/api/expenses/receipts/${this.receipt.id}/image`;
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;

						if (status === 200) {
							const eleLink = document.createElement('a');

							const userAgent = navigator.userAgent;
							if (userAgent.includes('Firefox')) {
								eleLink.download = `JBX_${this.receipt.id}/image`;
							}
						
							eleLink.style.display = 'none';
							if (!this.$vuetify.breakpoint.smAndDown) {
								eleLink.target = '_blank';
							}
							eleLink.href = URL.createObjectURL(data);
							document.body.appendChild(eleLink);
							eleLink.click();
							document.body.removeChild(eleLink);
							window.URL.revokeObjectURL(eleLink.href);
						}
					})
					.catch((e) => {
						console.log('error message:', e.message);
					});
			}
		},
		openZoom() {
			if (this.image_save_obj) {
				const url = URL.createObjectURL(this.image_save_obj.blob);
				this._showImage(this.image_save_obj.blob, url);

			} else {
				const url = this.receipt.image ? this.receipt.image: `/api/expenses/receipts/${this.receipt.id}/image`;
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;

						if (status === 200) {
							this._showImage(data, url);
						}
					})
					.catch((e) => {
						console.log('error message:', e.message);
					});
			}
		},
		_showImage(data, url) {
			if (data.type === PDF_TYPE) {
				const reader = new FileReader();
				reader.readAsDataURL(data); 
				reader.onload = readerEvent =>  {
					const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
					loadingTask.promise.then(pdf => {
						const preview_url = [];
						let page_total = pdf.numPages;

						for (let index = 0; index < pdf.numPages; index++) {
							pdf.getPage(index + 1).then(page => {
								const scale = SCALE;
								const viewport = page.getViewport({scale: scale});

								const canvas = document.createElement('canvas');
								const context = canvas.getContext('2d');
								canvas.width = viewport.width;
								canvas.height = viewport.height;

								const renderContext = {
									canvasContext: context,
									viewport: viewport
								};

								const renderTask = page.render(renderContext);
								renderTask.promise.then(() => {
									canvas.toBlob(blob => {
										const preview_item_url = URL.createObjectURL(blob);
										preview_url.push(preview_item_url);
										page_total -= 1;

										if (page_total === PAGE_INIT) {
											let image_width = 0;
											let image_height = 0;

											const isMobile = window.innerWidth < 600
											if (isMobile) {
												/** this.$vuetify.breakpoint.width <= 600 */
												const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
												image_width = max_width;
												image_height = max_width * (viewport.height / viewport.width);

											} else {
												/** this.$vuetify.breakpoint.width >= 960 */
												const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
												image_width = max_height * (viewport.width / viewport.height);
												image_height = max_height;
											}
											const show_image = {
												image: preview_url,
												image_width: image_width,
												image_height: image_height,
												url: url
											};

											this.show_image = show_image;
											this.image_visible = true
										}
									});									
								});
							});
						}
					});
				};
							
			} else {
				const my_image = new Image();
				const preview_item_url = URL.createObjectURL(data);
				my_image.src = preview_item_url;

				my_image.onload = () => {
					let image_width = 0;
					let image_height = 0;

					if (this.$vuetify.breakpoint.smAndUp) {
						const max_height = this.$vuetify.breakpoint.height - Max_Distance_Window;
						image_width = max_height * (my_image.width / my_image.height);
						image_height = max_height;
					} else {
						/* 48 = padding-left-24px + padding-right-24px */
						const max_width = this.$vuetify.breakpoint.width - Max_Distance_Mobile;
						image_width = max_width;
						image_height = max_width * (my_image.height / my_image.width);
					}

					const show_image = {
						image: [preview_item_url],
						image_width: image_width,
						image_height: image_height,
						url: url
					};

					this.show_image = show_image;
					this.image_visible = true;
				}
			}
		},
		_resizeByQuality(img, q) {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const context = canvas.getContext('2d');
			context.drawImage(img,0,0, img.width, img.height);
			return canvas.toDataURL("image/jpeg", q);
		},
		_dataURItoBlob(dataURI) {
			// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
			// convert base64 to raw binary data held in a string
			// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
			var byteString = atob(dataURI.split(',')[1]);

			// separate out the mime component
			var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to an ArrayBuffer
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ab], {type: mimeString});
		},
		_checkKind(job_id, kind_id, phase_id) {
			let url = `/api/jobs/${job_id}/can_do_kind`;

			const params = [];
			params.push("kiid=" + kind_id);
			params.push("jpid=" + phase_id);


			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							if (data.can_do_client && data.can_do_jobtype) {
								resolve(true);
							} else {
								resolve(false);
							}
							
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		_getPhases(job_id) {
			const url = `/api/jobs/${job_id}/phases`;

			axios.get(url, {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.phases_local = data;
						
						// auto assign our phase if there is only one..
						const phases_arr = data;
						if (phases_arr.length !== 0) {
							this.phase = phases_arr[0];
						} else {
							this.phase = null;
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_imageCheckAndSave() {
			if (!this.image_origin && !this.image) {
				const update_receipt = this._createReceiptObj();
				this.$emit('save', update_receipt);
			}

			/** delete the image if changes */
			if (this.image_origin && !this.image) {
				this.delete_receipt_for_image().then(() => {
					this.overlay = false;
					const update_receipt = this._createReceiptObj();
					this.$emit('save', update_receipt);
				})
					.catch(msg => {
						this.overlay = false;
						this.error_msg = msg.message;
					});
			}

			/** update the image if changes */
			if (!this.image_origin && this.image) {
				this.upload_receipt_for_image(this.image_save_obj).then(() => {
					this.overlay = false;
					const update_receipt = this._createReceiptObj();
					this.$emit('save', update_receipt);
				})
					.catch(msg => {
						this.overlay = false;
						this.error_msg = msg.message;
					});
			}
				
			/** update the image if changes */
			if (this.image_origin && this.image) {
				if (typeof(this.image_origin) !== typeof(this.image)) {
					this.upload_receipt_for_image(this.image_save_obj).then(() => {
						this.overlay = false;
						const update_receipt = this._createReceiptObj();
						this.$emit('save', update_receipt);
					})
						.catch(msg => {
							this.overlay = false;
							this.error_msg = msg.message;
						});
				} else {
					if (typeof(this.image_origin) === 'string') {
						if (this.image_origin !== this.image) {
							this.upload_receipt_for_image(this.image_save_obj).then(() => {
								this.overlay = false;
								const update_receipt = this._createReceiptObj();
								this.$emit('save', update_receipt);
							})
								.catch(msg => {
									this.overlay = false;
									this.error_msg = msg.message;
								});
						} else {
							const update_receipt = this._createReceiptObj();
							this.$emit('save', update_receipt);
						}
					} else {
						if (this.image_origin.length !== this.image.length) {
							this.upload_receipt_for_image(this.image_save_obj).then(() => {
								this.overlay = false;
								const update_receipt = this._createReceiptObj();
								this.$emit('save', update_receipt);
							})
								.catch(msg => {
									this.overlay = false;
									this.error_msg = msg.message;
								});
						} else {
							if (this.image_origin[0] !== this.image[0]) {
								this.upload_receipt_for_image(this.image_save_obj).then(() => {
									this.overlay = false;
									const update_receipt = this._createReceiptObj();
									this.$emit('save', update_receipt);
								})
									.catch(msg => {
										this.overlay = false;
										this.error_msg = msg.message;
									});
							} else {
								const update_receipt = this._createReceiptObj();
								this.$emit('save', update_receipt);
							}
						}
					}
				}
			}
		},
		_createReceiptObj() {
			let image_tmp = null;
			if (this.image_type.length !== 0) {
				if (this.image_type !== this.pdf_file_type) {
					image_tmp = `/api/expenses/receipts/${this.receipt.id}/thumbnail`;
				}
			}

			const new_receipt = {
				id: this.receipt.id,
				employee: this.receipt.employee ? this.receipt.employee : null,
				description: this.description ? this.description : '',
				date: moment(this.expenses_date).format("YYYY-MM-DD"),
				currency: this.currency,
				has_tax: this.has_tax,
				job: this.job ? this.job : null,
				phase: this.phase ? this.phase : null,
				kind: this.kind ? this.kind : null,
				is_used: this.receipt.is_used,
				ocr: this.receipt.ocr,
				image: image_tmp,
				image_type: this.image_type,
				thumbnail: this.receipt.thumbnail,
				value: Number(this.amount),
				tax_amount: Number(this.tax_amount),
				amount: this.parseAmount(this.toPay),
				tax_mode: this.tax_setting.value,
				tax_perc: this.tax_perc,
				receipt_id: this.receipt.id,
				markup_perc: this.markup_perc,
				markup_value: this.parseAmount(this.markupValue),
			};

			return new_receipt;
		},
		_getBlobDate(url) {
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					},
					responseType: 'blob',
				})
				.then((val) => {
					const { status, data } = val;
					if (status === 200) {
						const reader = new FileReader();
						reader.readAsDataURL(data); 
						reader.onload = readerEvent =>  {
							const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
							loadingTask.promise.then(pdf => {
								const preview_url = [];
								let page_total = pdf.numPages;

								for (let index = 0; index < pdf.numPages; index++) {
									pdf.getPage(index + 1).then(page => {
										const scale = SCALE;
										const viewport = page.getViewport({scale: scale});

										const canvas = document.createElement('canvas');
										const context = canvas.getContext('2d');
										canvas.width = viewport.width;
										canvas.height = viewport.height;

										const renderContext = {
											canvasContext: context,
											viewport: viewport
										};

										const renderTask = page.render(renderContext);
										renderTask.promise.then(() => {
											canvas.toBlob(blob => {
												const preview_item_url = URL.createObjectURL(blob);
												preview_url.push(preview_item_url);
												page_total -= 1;

												if (page_total === PAGE_INIT) {
													let image_width = 0;
													let image_height = 0;

													if (this.$vuetify.breakpoint.smAndDown) {
														/* 48 = padding-left-24px + padding-right-24px */
														if (viewport.width > viewport.height) {
															image_width = this.$vuetify.breakpoint.width - 48;
															image_height = (this.$vuetify.breakpoint.width - 48) * viewport.height / viewport.width;
														} else {
															image_height = this.$vuetify.breakpoint.width - 48;
															image_width = (this.$vuetify.breakpoint.width - 48) * viewport.width / viewport.height;
														}
													} else {
														if (viewport.width > viewport.height) {
															image_width = this.max_width;
															image_height = this.max_width * viewport.height / viewport.width;
														} else {
															image_height = this.max_width;
															image_width = this.max_width * viewport.width / viewport.height;
														}
													}

													this.image_width = image_width;
													this.image_height = image_height;
													this.image = preview_url;	
													this.image_origin = preview_url;											
												}
											});									
										});
									});
								}
							});
						};
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
	}
}
</script>
<style lang="scss" scoped>
.receipt-col {
	padding: 10px;
}
.receipt-box {
	background: #FFFFFF;
	padding: 20px;
	border: 1px solid rgba(25, 42, 62, 0.3);
	border-radius: 4px;
}
.receipt-loading {
	width: auto;
	max-width: 90%;
	min-width: 600px;
}
.receipt-box-close {
	.close {
		&:hover {
			cursor: pointer;
		}
	}
}
.receipt-box-row {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.receipt-box-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #37495F;
}
.receipt-box-btn {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	:first-child {
		padding: 0 20px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		border-radius: 4px;
		margin-right: 8px;
	}
	:last-child {
		padding: 0 20px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		border-radius: 4px;
	}
}
.receipt-box-btn-sm {
	justify-content: center;
}
.receipt-box-btn-lg {
	justify-content: flex-start;
}
.receipt-box-btn-copy {
	justify-content: center;
}
.receipt-box-btn-more {
	justify-content: space-between;
}
.btn-able {
	color: #FFFFFF;
	background: #00AAFD;
	border: 1px solid #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.btn-remove-able {
	color: rgba(25, 42, 62, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
	&:hover {
		cursor: pointer;
	}
}
.btn-disable {
	color: rgba(25, 42, 62, 0.3);
	border: 1px solid rgba(25, 42, 62, 0.3);
}
.more-text {
	float: right;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	color: #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.blob-text {
	font-family: Roboto;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0.5px;
}
.image-loading {
	background:#C4C4C4;
}
.image-remove {
	position: relative;
	top: -50px; 
	right: -10px;
}
.image-zoom {
	float: right;
	top: -50px;
	right: 10px;
}
.hidden {
	display: none;
}
.image-show-box {
	position: absolute;
	display: block;
	&:hover {
		cursor: pointer;
	}
}
.wrap-div {
	overflow: hidden;
	width: 100%;
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.mark-up-field ::v-deep .v-input__append-inner .v-icon {
	font-size: 16px;
}
</style>
